// src/styles/theme.js
// ─────────────────────────────────────────────────────────────
// CHARTE GRAPHIQUE — modifier uniquement ce fichier pour changer le design.

export const C = {
  // Fonds
  bg:       '#FAF7F2',  // crème — fond général
  bgCard:   '#FFFFFF',  // blanc — cartes
  bgMuted:  '#F2EDE6',  // crème moyen — zones secondaires

  // Couleurs principales
  rose:      '#E8A4A4', roseDark:  '#C97B7B',
  peach:     '#F0C4A8', peachDark: '#D4956A',
  lilas:     '#C4B5E8', lilasDark: '#8B78C4',
  sage:      '#B4CDB4', sageDark:  '#6A9B6A',

  // Neutres
  sand:      '#DDD3C4',
  text:      '#3D2E24',
  textMid:   '#7A6058',
  textLight: '#B09880',
  white:     '#FFFFFF',

  // Fonds de cartes par type
  cardAction:   '#D4EBF0',
  cardVerite:   '#E8D4F0',
  cardPunition: '#F0D4E8',
  cardDate:     '#D4F0E0',
  cardDist:     '#F5E6D0',
  cardConseil:  '#EDF0D4',
  cardRessource:'#D4E8F0',
};

// Niveaux d'intensité
export const INTENSITY = {
  1: { label: 'Doux',    icon: '🌿', color: '#B4CDB4' },
  2: { label: 'Pimenté', icon: '🌶️', color: '#F0C4A8' },
  3: { label: 'Intense', icon: '🔥', color: '#E8A4A4' },
};

// Fond de carte selon le type
export const CARD_BG = {
  action:    '#D4EBF0',
  verite:    '#E8D4F0',
  punition:  '#F0D4E8',
  date:      '#D4F0E0',
  conseil:   '#EDF0D4',
  ressource: '#D4E8F0',
};

// Dégradés boutons
export const GRADIENTS = {
  primary:   'linear-gradient(135deg, #E8A4A4, #F0C4A8)',
  secondary: 'linear-gradient(135deg, #C4B5E8, #8B78C4)',
  dist:      'linear-gradient(135deg, #C4B5E8, #E8A4A4)',
  warm:      'linear-gradient(135deg, #F5E6D0, #F0C4A8)',
  teal:      'linear-gradient(135deg, #B4CDB4, #C4B5E8)',
};

export const FONTS = {
  display: "'DM Serif Display', serif",
  body:    "'DM Sans', sans-serif",
};

export const RADIUS = { sm: 12, md: 16, lg: 20, xl: 24, pill: 50 };
